import { render } from "./Treatments.vue?vue&type=template&id=dd645f2c&scoped=true"
import script from "./Treatments.vue?vue&type=script&lang=js"
export * from "./Treatments.vue?vue&type=script&lang=js"

import "./Treatments.vue?vue&type=style&index=0&id=dd645f2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd645f2c"]])

export default __exports__